module.exports = __webpack_public_path__ + "static/media/eight.bae7f229.png";